export const exclude = [
  '/codewindow',
  '/sales/return/code/window',
  '/purchase/return/code/window',
  '/transaction/sales/create/',
  '/transaction/sales/edit/',
  '/ledger-details/reports/',
  '/stock/detail/report/',
  '/stock/ledger/report/',
  '/ledger/reports/',
  '/stock-summary/reports/',
  '/sundry-creditors/reports/',
  '/sundry-ledger-details/reports/',
  '/debtors-ledger-details/reports/',
  '/cash-bank-ledger-details/reports/',
  '/ledger/cash-bank/reports/',
  '/karigar/ledger-details/reports/',
  '/ledger/karigar/reports/',
  '/sundry-debtors/reports/',
  '/ledger/karigar/reports/',
  '/karigar/ledger-details/reports/',
];
